import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonSplitPane,
} from "@ionic/vue";
import {ref} from "vue";
import router from "./router";


import {IonApp, IonRouterOutlet} from "@ionic/vue";


import {defineComponent, inject} from "vue";
import {AxiosInstance} from "axios";
import ApiService from "@/services/ApiService";

const __default__ = defineComponent({
  name: "App",
  components: {IonApp, IonRouterOutlet},

  mounted() {
    const api = new ApiService();
    api.getDepartments();
    api.getTradeshows();
    api.getCountries();
    api.getQualificationLevels()
  }
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const selectedIndex = ref(0);
const appPages = router.options.routes.filter(
    (route) => route.meta && route.meta.title
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
    ]),
    _: 1
  }))
}
}

})